//this will eventually come from the component that uses the hook, here for simplicity
export const ARROW_HEIGHT = 10;
export const MAX_ENTRY_CONTENT_HEIGHT = 700;
